/**************************************************
 * Nombre:       Formulario_SubCategoria
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {AccountTreeOutlined, Layers} from "@mui/icons-material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import {CATEGORIAS} from "../../Constantes";


const Formulario_SubCategoria = ({...props}) => {


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={12}>
                    <IngresoTexto Icono={AccountTreeOutlined} nombre={'Nombre Sub Categoria'}
                                  dato={'nombre'} {...props}

                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoSelect Icono={Layers} nombre={'Categoria'}
                                  dato={'categoria'} {...props} opciones={CATEGORIAS.map((it) => it.nombre)}

                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_SubCategoria